<template>
  <global-modal
    :active="isActive"
    @toggleActive="toggleActive"
    :disableClose="true"
  >
    <div class="text-center bg-primary-gradient py-10">
      <div class="w-full ">
        <feather-icon
          icon="AwardIcon"
          class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
          svgClasses="h-8 w-8"
        ></feather-icon>
      </div>
    </div>

    <div class="w-full text-center px-4 py-10">
      <h1 class="mb-5">
        {{ title }}
      </h1>
      <vs-progress
        :height="12"
        :percent="progress"
        color="primary"
        class=""
      ></vs-progress>
      <p class="mb-5">
        {{ `${progress} %` }} <br>
        <span v-if="progress >= 100">File berhasil di upload</span>
      </p>
    </div>

    <section class="mb-5 flex justify-center" slot="footer">
      <div v-if="progress >= 100">
        <vs-button
          class="mx-1"
          type="border"
          color="primary"
          @click="handleOnAccept"
        >
          {{ acceptTitle }}
        </vs-button>

        <vs-button
          class="mx-1"
          type="border"
          color="danger"
          @click="handleOnCancel"
        >
          {{ cancelTitle }}
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
export default {
  props:{
    title: {
      type: String,
      default: 'Upload Dokumen'
    },
    progress: {
      type: Number,
      default: 0
    },
    acceptTitle: {
      type: String,
      default: 'OK'
    },
    cancelTitle: {
      type: String,
      default: 'Batal Upload'
    },
  },
  data() {
    return {
      isActive: false
    };
  },
  watch: {
    progress: {
      handler(){
        if(this.progress == 100 && this.isActive){
          this.$vs.notify({
            title: 'Pemberitahuan',
            text: `Berhasil menambah dokumen`,
            color: "primary",
            position: "top-right"
          });
        }
      }
    }
  },
  methods: {
    toggleActive(isActive) {
      this.isActive = isActive;
    },
    async handleOnAccept() {
      this.isActive = false;
      this.$emit('onAccept');
    },
    async handleOnCancel() {
      this.isActive = false;
      this.$emit('onCancel');
    }
  }
};
</script>
